
export default [{
	path: '/customers-cards',
	component: () => import('@/components/customers-cards/List')
}]
